export type VoiceReplyCommandParse = {
  text: string
  shouldSend: boolean
}

const TRAILING_SEND_REPLY_COMMAND_RE =
  /(?:^|[\s,.;:!?])(?:please\s+)?send\s+(?:(?:the|my)\s+)?(?:reply|message|it)\s*[.!?]*$/i

export function parseVoiceReplyCommand(input: string): VoiceReplyCommandParse {
  const trimmed = input.trim()
  if (!trimmed) return { text: '', shouldSend: false }

  const match = trimmed.match(TRAILING_SEND_REPLY_COMMAND_RE)
  if (!match || typeof match.index !== 'number') {
    return { text: trimmed, shouldSend: false }
  }

  return {
    text: trimmed.slice(0, match.index).trim().replace(/[,;:]+$/, '').trim(),
    shouldSend: true,
  }
}
